import React, { FC, PropsWithChildren, Suspense, useEffect } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { useQueryLoader } from 'react-relay';

import {
  EdSkeleton,
  GlobalSettingsManager,
  GlobalSettingsManagerQuery,
  GlobalSettingsQueryDef,
  Loading,
} from 'shared-ui';
import { ErrorBoundaryFallback } from 'app-core';
import {
  PlatformHosts,
  getClientEnvironment,
  getPlatformHost,
  getPlatformHostUrl,
} from 'shared-lib';

import './App.css';
import { NoInternet, PwaLoader } from './components';

export const AppLoader: FC<PropsWithChildren> = ({ children }) => {
  const host = getPlatformHost();
  const environment = getClientEnvironment();

  // Redirect users to Myn if they are on Elevate and not on localhost
  if (
    host === PlatformHosts.Elevate &&
    environment !== 'local' &&
    environment !== 'localhost' &&
    environment !== 'develop'
  ) {
    const host = getPlatformHostUrl(environment);
    window.location.href =
      host('myn.co.uk') + window.location.pathname + window.location.search;
  }

  const [queryRef, loadQuery] = useQueryLoader<GlobalSettingsManagerQuery>(
    GlobalSettingsQueryDef,
  );

  useEffect(() => {
    console.log(`Loading Settings From Server`);
    loadQuery({});
  }, []);

  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
      <PwaLoader />
      {queryRef ? (
        <GlobalSettingsManager queryRef={queryRef}>
          <Suspense fallback={<Loading label='Loading Shell...' />}>
            {children}
          </Suspense>
        </GlobalSettingsManager>
      ) : (
        <EdSkeleton />
      )}
    </ErrorBoundary>
  );
};

const withInternet = (component: any) => {
  if (window.navigator.onLine) {
    return component;
  } else {
    return NoInternet;
  }
};
export default withInternet(AppLoader);
